import React from 'react';
import MuiFormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputBase from '@material-ui/core/InputBase';
import FormHelperText from '@material-ui/core/FormHelperText';
import { OutlinedTextFieldProps } from '@material-ui/core/TextField/TextField';
import { withStyles, createStyles } from '@material-ui/styles';
import { Theme, fade } from '@material-ui/core/styles';

const FormControl = withStyles((theme: Theme) =>
  createStyles({
    root: {
      //   marginTop: theme.spacing(3),
      '& > label.MuiFormLabel-root': {
        ...theme.typography.body1,
        color: theme.palette.text.primary,
        transform: 'none',
        position: 'initial',
        lineHeight: 1.1
      }
    }
  })
)(MuiFormControl);

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    input: {
      position: 'relative',
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main
      }
    }
  })
)(InputBase);

/** TextField
 * copy from https://github.com/mui-org/material-ui/blob/v4.4.3/packages/material-ui/src/TextField/TextField.js
 * and masked to behave as web-order old input (until update)
 */
export interface TextFieldProps
  extends Omit<OutlinedTextFieldProps, 'variant'> {
  dataFd: string;
}

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  function TextField(props, ref) {
    const {
      autoComplete,
      autoFocus,
      children,
      classes,
      className: classNameProp,
      defaultValue,
      error,
      FormHelperTextProps,
      fullWidth,
      helperText,
      hiddenLabel,
      id,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      multiline,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      rowsMax,
      select = false,
      SelectProps,
      type,
      value,
      //   variant = 'outlined',
      dataFd,
      ...other
    } = props;

    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;

    return (
      <FormControl
        className={classNameProp}
        error={error}
        fullWidth={fullWidth}
        hiddenLabel={hiddenLabel}
        required={required}
        {...other}
      >
        {label && (
          <InputLabel
            htmlFor={id}
            id={inputLabelId}
            shrink
            disableAnimation
            {...InputLabelProps}
          >
            {label}
            {required && '\u00a0*'}
          </InputLabel>
        )}
        <BootstrapInput
          aria-describedby={helperTextId}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          fullWidth={fullWidth}
          multiline={multiline}
          name={name}
          rows={rows}
          rowsMax={rowsMax}
          type={type}
          value={value}
          id={id}
          inputRef={inputRef}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          inputProps={{
            ...inputProps,
            ...{ 'data-lpignore': 'true', 'data-fd': dataFd }
          }}
          {...InputProps}
        />
        {helperText && (
          <FormHelperText id={helperTextId} {...FormHelperTextProps}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  }
);

export default TextField;
